import styled, { css } from 'styled-components';

export const PaginationWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;  
`;

export const Container = styled.div`
  ${({ theme }) => css`
    background: ${theme.v3.colors.neutral[100]};
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    flex-wrap: wrap;
    padding: 8px;
  `}
`;

export const NavigationButton = styled.button`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border: 0;
    padding: 0;
    background: ${theme.v3.colors.neutral[100]};
    cursor: pointer;
    transition: all 0.2s ease;
    border-radius: 4px;

    &:disabled {
      cursor: not-allowed;
    }

    &:active:not(:disabled) {
      transform: scale(0.95);
    }
  `}    
`;

export const PageButton = styled(NavigationButton)`
  ${({ theme, $active }) => css`
    font-size: 14px;
    line-height: 1.5;
    font-family: ${theme.v3.font.family.brand};
    font-weight: ${theme.v3.font.weights.regular};
    color: ${theme.v3.colors.neutral[60]};

    &:hover:not(:disabled) {
      color: ${theme.v3.colors.neutral[50]};
    }

    ${$active && css`
      color: ${theme.v3.colors.brand.snappyBlue[50]};
      background: ${theme.v3.colors.brand.snappyBlue[95]};
      font-weight: ${theme.v3.font.weights.medium};
    `}
  `}
`;

export const Ellipsis = styled(PageButton)`
  user-select: none;
  cursor: default;
`;
